export default __webpack_public_path__ + "static/media/Asset 18.d6f2b888.png";